import React from 'react';
import AboutMainWrap from "../style/wrap";
import Container from "../../../../components/paper/container";
import SectionTitle from "../../../../components/heading/section";
import {Button, Card, Col, Row, Space} from "antd";
import CardTitle from "../../../../components/heading/card";
import P1 from "../../../../components/paragraph";
import ChartImage1 from '../../../../assets/img/landlord1.png'
import ChartImage2 from '../../../../assets/img/landlord2.png'
import ChartImage3 from '../../../../assets/img/landlord3.png'
import styled from "styled-components"
import {Icon} from '@iconify/react';
import AuthLayout from '../../../../layouts/auth.layout';

const AboutMain = () => {
    return (
        <AboutMainWrap>
            <Container>
                <Space direction='vertical' size={32} style={{width: '100%', paddingTop: '20px'}}>
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 24}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <P1>
                                    <div>
                                      <h2 id="online-rental-payment-benefits-for-landlords">Benefits Of iCard</h2>
                                      {/* <p>Adopting online rent payments is a strategic business decision that increases operational efficiency and tenant satisfaction in a variety of ways. Here are a few examples:</p> */}
                                      <ul>
                                        <li><p><strong>No More Filling Out Applications</strong><br/>No more filling out rental applications. Simply share your rental profile with landlords to apply.</p></li>
                                        <li><p><strong>One Click Easy Apply Online Application Saves Time</strong><br/>By eliminating the need to fill out rental applications iCard&apos;s One Click Easy Apply saves you a world of time so you can focus on your life.</p></li>
                                        <li><p><strong>Identity Verification & Fraud Protection</strong><br/>iCard verifies your identity, tokenizes it and thus protects you from online fraud.</p></li>
                                        <li><p><strong>Save Money On Fees</strong><br/>iCard saves you hundreds in fees by reusing your verified profile over and over.</p></li>
                                        <li><p><strong>Credit Rating Protection</strong><br/>Everytime landlords lookup your credit or do a background check your credit score goes down a few points. By reusing your iCard profile you protect your credit rating from getting impacted from landlord lookups.</p></li>
                                        <li><p><strong>No More Searching Receive Rentals That Fit Your Criteria</strong><br/>Receive notifications of rentals that fit your criteria and preferences such as budget, area, specification such as bedrooms, garage, washer, dryer etc. sent to you.</p></li>
                                        <li><p><strong>Tenant Screening</strong><br/>blah blah blah blah blah blah</p></li>
                                        <li><p><strong>Keeping Your Data Private From Landlords</strong><br/>iCard cerifies your private information and encrpyts it so landlords or bad actors can&apos;t reuse it.</p></li>
                                        <li><p><strong>Digital Record Keeping</strong><br/>iCard maintains digital records of rental applications, leases, rent payments, maintenance records and other communication making tracking and monitoring of rent payments and service requests a breeze.</p></li>
                                        <li><p><strong>Online Rent Payments</strong><br/>Pay your rent from anywhere with your iCard.</p></li>
                                        <li><p><strong>Automate Payment Reminders</strong><br/>One of the many benefits of iCard is the ability to automate rent processing. Setting up automatic payment reminders can help you remember to pay their rent on time.</p></li>
                                        <li><p><strong>Maintence & Service Requests</strong><br/>Send and track maintenance and service requests from iCard.</p></li>
                                      </ul>     
                                  </div>
                                </P1>                   
                            </Space>
                        </Col>
                    </Row>
                </Space>
            </Container>
        </AboutMainWrap>
    );
};

const ActionFormCard = styled(Card)`
  box-shadow: none;
  border: none;
  background: linear-gradient(to top, #f4e1ff, #f4e1ff);
  border-radius: 12px;
  padding: 0px;

  h2 {
    text-align: center;
    //font-size: 28px;
    margin-bottom: 0px;
  }

  h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`

export default AboutMain;
